AppTabs.createTab( {
name: 'collection-methods',
icon: 'list-alt',
text: 'Collection Methods',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-collection-methods',

		readTableName: 	'tblCollectionMethods',
		editTableName: 	'tblCollectionMethods',
		primaryKey: 	'CollectionMethodID',

		canSort:			false,
		paging:				false,

		actionData:			'datatable',
		actionAutofill: 	'datatable_autofill',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'collectionMethodOptions' );
		},

		fields: [
			{
				label: 		'',
				columnName: 'CollectionMethod',
				isEditable: true,
				order: 		'asc',
			},
		],

	} );
}

} );
